export const SEARCH_PARAM = "sq";